__turbopack_context__.v({
  "button": "cart-product-card-module__NTPBra__button",
  "cardContent": "cart-product-card-module__NTPBra__cardContent",
  "cardWrapper": "cart-product-card-module__NTPBra__cardWrapper",
  "chip": "cart-product-card-module__NTPBra__chip",
  "chips": "cart-product-card-module__NTPBra__chips",
  "footer": "cart-product-card-module__NTPBra__footer",
  "isMobile": "cart-product-card-module__NTPBra__isMobile",
  "name": "cart-product-card-module__NTPBra__name",
  "price": "cart-product-card-module__NTPBra__price",
});
